var _path, _g, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 110.3 612 559.7",
    enableBackground: "new 0 110.3 612 559.7",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M263.5,296.3l136.3,78.5c23.5,13,23.5,47,0,60l-136.3,79.2c-23.5,13-52.1-3.6-52.1-30V326.3 C211.4,299.9,240,283.3,263.5,296.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M567.1,148.7c-24.8,0-44.9,20.1-44.9,44.9c0,24.8,20.1,44.9,44.9,44.9c24.8,0,44.9-20.1,44.9-44.9 C612,168.8,591.9,148.7,567.1,148.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M481.5,154.8c12.3,0.5,22.6-9.1,23-21.4c0.5-12.3-9.1-22.6-21.4-23c-12.3-0.4-22.6,9.1-23,21.4 C459.6,144,469.2,154.3,481.5,154.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M28.8,572.1c-14.3-0.5-26.4,10.7-26.9,25c-0.5,14.4,10.7,26.4,25,26.9c14.3,0.5,26.4-10.7,26.9-25 C54.4,584.7,43.2,572.6,28.8,572.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M285.1,140.6c-3,0.2-5.9,0.3-8.9,0.5C130.4,153.6,22.4,282,34.9,427.8c1.2,14.3,3.6,28.3,7,41.8 C59,538.1,102.4,595.2,160,630.7c46.7,28.8,102.7,43.4,161.5,38.3c99-8.5,180.5-70.4,218.8-155c18.1-39.9,26.5-84.9,22.5-131.7 C550.5,239.6,427.2,133.1,285.1,140.6z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M257.9,285.4l154.8,89.1c26.7,14.8,26.7,53.4,0,68.1l-154.8,89.9c-26.7,14.8-59.1-4.1-59.1-34.1v-179 C198.8,289.5,231.2,270.6,257.9,285.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.f7f07271a7e8733041385c2d35cbe767.svg";
export { ForwardRef as ReactComponent };